import userApi from './api/userApi';
import config from "../config";

// export const USER_SETAUTHENTICATION = 'user/SETAUTHENTICATION';
export const USER_LOGIN = 'user/LOGIN';
// export const USER_LOGOUT = 'user/LOGOUT';
// export const USER_SESSION = 'user/SESSION';
// export const USER_PREVIOUS_URL = 'user/PREVIOUSURL';
// export const USER_PROFILE = 'user/PROFILE';

const initialState = {
	userAuthenticated: (localStorage.u) ? true : false,
	userProfile: (localStorage.u) ? JSON.parse(localStorage.u) : {},
// 	previousURL: null,
}

export default (state = initialState, action) => {
	switch (action.type) {
		// case USER_SETAUTHENTICATION:
		// 	return {
		// 		...state,
		// 		isAuthenticated: action.payload
		// 	};

		case USER_LOGIN:
			return {
				...state,
				userAuthenticated: true,
				userProfile: action.payload
			};

	// 	case USER_LOGOUT:
	// 		return {
	// 			...state,
	// 			isAuthenticated: false,
	// 		};

	

	// 	case USER_PREVIOUS_URL:
	// 		return {
	// 			...state,
	// 			previousURL: action.payload
	// 		};

	// 	case USER_PROFILE:
	// 		return {
	// 			...state,
	// 			userProfile: action.payload
	// 		};


		default:
			return state;

	}
};

// export const userSetAuthentication = (payload) => {
// 	return dispatch => {
// 		dispatch({
// 			type: USER_SETAUTHENTICATION,
// 			payload
// 		});
// 	};
// };

export const userLogin = (payload) => {
	return dispatch => {
		return userApi.UserLogin(payload).then(data => {
			delete data.message;

			dispatch({
				type: USER_LOGIN,
				payload: data
			});

			localStorage.setItem('u', JSON.stringify(data));

			return data;
		}).catch(error => {
			throw(error);
		});
	};
};

// export const userLogout = () => {
// 	return dispatch => {
// 		var payload = {
// 			sessionToken: localStorage.session_token,
// 			channelPartnerID: localStorage.channel_partner_id,
// 		};
// 		localStorage.removeItem('session_token');
// 		localStorage.removeItem('channel_partner_id');
// 		localStorage.removeItem('u');
// 		localStorage.removeItem('watchlist');
// 		localStorage.removeItem('parentalPINValid');
// 		return userApi.UserLogout(payload).then(data => {
// 			dispatch({
// 				type: USER_LOGOUT
// 			});
// 		}).catch(error => {
// 			throw(error);
// 		});
// 	};
// };

// export const userSetPreviousURL = (payload) => {
// 	return dispatch => {
// 		dispatch({
// 			type: USER_PREVIOUS_URL,
// 			payload
// 		});
// 	};
// };

// export const userGetProfile = (token, id) => {
// 	return dispatch => {
// 		return userApi.UserGetProfile(token, id).then(data => {
// 			delete data.message;

// 			dispatch({
// 				type: USER_PROFILE,
// 				payload: data,
// 			});

// 			// if (window.location.hash !== '#activate') {
// 				localStorage.setItem('u', JSON.stringify(data));
// 			// }

// 			return data;
// 		}).catch(error => {
// 			throw(error);
// 		});
// 	};
// };


// export const userAuthenticateCustomerForOperator = (token, id) => {
// 	return dispatch => {
// 		return userApi.UserAuthenticateCustomerForOperator(token, id).then(data => {
// 			delete data.message;
// 			dispatch({
// 				type: USER_SESSION,
// 				payload: data,
// 			});

// 			// if (window.location.hash !== '#activate') {
// 				localStorage.setItem('u', JSON.stringify(data));
// 			// }

// 			return data;
// 		}).catch(error => {
// 			throw(error);
// 		});
// 	};
// };



// export const userUpdateProfile = (payload) => {
//   return dispatch => {
//     return userApi.UserUpdateProfile(payload).then(data => {
//       return data;
//     }).catch((error) => {
//       throw(error);
//     })
//   }
// }
